// Synthetic specimen report for the design gallery (2026-07-29, P0 fix).
// Hand-authored, obviously-fake data ONLY — entity ids, names, metrics, and
// narratives are invented for design evaluation. The gallery previously
// imported the real HO1 fixture dossiers, which statically bundled ~1.4 MB of
// real customer data into the publicly downloadable admin bundle (AdminRoute
// gates rendering, not the bundle). Fixtures remain test-only; nothing here
// may import from __fixtures__.
//
// Shape mirrors what InvestigationReport actually consumes: summary (bluf,
// totals), entitySummaries (severity, diagnosis, findings, peerEvidence,
// synthesisJson), probeIndex, statistics, contextMetadata, statusDistribution.

const entity = (entityId, severity, overrides = {}) => ({
    entityId,
    entityType: 'Store',
    displayEntityId: `Store ${entityId}`,
    severity,
    diagnosis: 'synthetic_decline_pattern → synthetic_indicator',
    investigationCount: 3,
    keyFindings: [`Synthetic finding for Store ${entityId} — invented for the gallery.`],
    ...overrides,
})

export const syntheticSpecimenReport = {
    artifactType: 'investigation_group',
    status: 'SUCCESS',
    timestamp: '2026-07-28T15:41:00Z',
    request: { entityType: 'Store' },
    contextMetadata: {
        displayName: 'Example Co — Weekly Store Screening (synthetic)',
        purpose: 'Synthetic screening context for design evaluation.',
        keyMetrics: ['Revenue YoY', 'Margin', 'Inventory Turns'],
    },
    summary: {
        bluf: 'Sales fell at 2 of 6 stores in this synthetic example; one shows the inventory death-spiral pattern.',
        narrative:
            'This narrative is **invented specimen content** for the design gallery.\n\n- It exercises markdown rendering\n- Without containing real customer data\n\nEvery value on this page is synthetic.',
        totalInvestigations: 18,
        highConfidenceCount: 2,
    },
    statistics: { totalEntities: 6, flaggedEntities: 2 },
    entitySummaries: [
        entity('9001', 'severe', {
            synthesisJson: {
                narrative: 'Synthetic severe entity — invented analysis text for layout evaluation.',
                questions_to_investigate: ['Why did synthetic margin compress in Q2?'],
            },
            peerEvidence: {
                'Revenue YoY|regional': {
                    metricLabel: 'Revenue YoY',
                    lens: 'regional',
                    entityValue: -18.2,
                    peerMedian: 2.1,
                    zScore: -2.4,
                    percentileRank: 0.05,
                    peerN: 11,
                    peerEntityIds: ['9002', '9003'],
                },
            },
        }),
        entity('9002', 'severe'),
        entity('9003', 'moderate'),
        entity('9004', 'mild'),
        entity('9005', 'healthy'),
        entity('9006', 'healthy', { unprobed: true, investigationCount: 0, keyFindings: [] }),
    ],
    probeIndex: [],
    investigations: [],
}
